<template>
    <div>
        <v-flex xs12 sm8 offset-sm2 md4 offset-md4>
          <v-card flat class="white ma-3 mb-5">
            <v-card-title>
              <div>
                <h5 class="subheading font-weight-medium">Name</h5>
              </div>
            </v-card-title>
            <template>
                  <v-text-field
                    solo
                    flat
                    name="name"
                    class="transparent mx-4"
                    v-model="userProfile.general.name"
                  ></v-text-field>
                  <v-btn
                    text
                    @click.exact="updateName"
                    class="mt-1 shadow_mx main ma-3"
                  >
                    <span>Update</span>
                  </v-btn>
            </template>
          </v-card>

          <v-card flat class="white ma-3 mb-5">
            <v-card-title>
              <div>
                <h5 class="subheading font-weight-medium">Email</h5>
              </div>
            </v-card-title>
             <v-text-field
                    solo
                    flat
                    name="name"
                    placeholder="new email"
                    class="transparent mx-4"
                    v-model="newEmail"
                  ></v-text-field>
            <template>
                  <v-btn
                    text
                    @click.exact="updateEmail"
                    class="mt-1 shadow_mx main ma-3"
                  >
                    <span>Change Email</span>
                  </v-btn>
            </template>
          </v-card>

          <v-card flat class="white ma-3 mb-5">
            <v-card-title>
              <div>
                <h5 class="subheading font-weight-medium">Password</h5>
              </div>
              <span style="word-break: keep-all" class="body-1">We will send you an email to {{currentUser.email}} </span>
            </v-card-title>
            <template>
                  <v-btn
                    text
                    @click.exact="updatePassword"
                    class="mt-1 shadow_mx main ma-3"
                  >
                    <span>Change Password</span>
                  </v-btn>
            </template>
          </v-card>

            <div class="center-me">
                     <v-btn class="white mt-5" @click="$router.go(-1)">Back</v-btn>
                  </div>
        </v-flex>
    </div>
</template>


<script>
import { mapState } from "vuex";
import { auth } from "@/firebase/async-firestore";
import firebase from 'firebase/app'

export default {
  name: "states",
  data() {
    return {
      icon: "mdi-arrow-right",
      newEmail: ''
    };
  },
  computed: {
    ...mapState("user", ["userProfile", "currentUser"]),
  },
  methods: {
    updateName() {
      const selectedContent = this.userProfile.general.name;
      const path = "general.name";
      this.$store
        .dispatch("user/triggerUpdateName", {
          selectedContent,
          path
        })
        .then(async () => {
          (await auth()).currentUser.updateProfile({
            displayName: selectedContent
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    async updatePassword() {
        var auth = firebase.auth();
        var emailAddress = this.currentUser.email;

        auth.sendPasswordResetEmail(emailAddress).then(() => {
        console.log('securrentUser')
        }).catch((error) => {
        console.log(error)
        });
    },
    async updateEmail () {
        var user = firebase.auth().currentUser;
        var vm = this

        user.updateEmail(vm.newEmail).then(async () => {
            firebase.firestore()
            .collection('users')
            .doc(vm.currentUser.uid)
            .update({
                "general.email": vm.newEmail
            })
        }).catch((error) => {
            console.log(error)
        });
    }
  }
};
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.btn-a {
  background: #bde3e1 !important;
  right: 0px;
}
</style>